import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountConfig } from '@shared/products-feature-configs';

import { statements } from '../statements-config/SK';
import { settingsDetails } from '../settings-details-config/SK';

export const currentAccount: DeepPartial<CurrentAccountConfig> = {
    overdraft: true,
    statements,
    roundingSavings: {
        enabled: false,
    },
    sepaMandatesRead: {
        enabled: false,
    },
    accountAddress: {
        enabled: false,
    },
    settingsDetails,
    layout: {
        productInfo: {
            showDisposableAndOwnResourcesAmounts: true,
        },
    },
    instantPaymentLimit: {
        showOwnTransferMessage: true,
    },
};
